import React from 'react';
import ClassSidebar from '../components/shared/ClassSidebar';
import { useState } from "react";
import { Button, ConfigProvider, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
const { Header, Content } = Layout;
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

const ClassLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <ConfigProvider theme={{}}>
      <Layout>
        <Header className="pl-0 pr-10 bg-background text-text_clr flex items-center justify-between border-b">
          <div className="flex items-center">
            <div className="w-[80px] flex justify-center">
              <Button
                type="text"
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={() => setCollapsed(!collapsed)}
              />
            </div>
            <div className="grid items-center h-16 font-semibold">
              <Link to="/" className="text-5xl text-center text-slate-400">
                G
              </Link>
            </div>
          </div>
          <Button variant="solid" color="danger">
            Logout
          </Button>
        </Header>
        <Layout className="h-[calc(100vh-64px)] flex flex-row ">
          <ClassSidebar collapsed={collapsed} />

          <div className="px-8 py-5 bg-background text-text_clr w-full">
            <Outlet />
          </div>

        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default ClassLayout;